import { createActionsHook } from 'src/lib/sweetState';

import { CustomerPersonaStore } from './CustomerPersonaStore';

export const useCustomerPersonaActions = createActionsHook(CustomerPersonaStore);
